// import logger from "redux-logger";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers/reducers";
import initialState from "../state/initialState";

const persistedReducer = persistReducer(
  {
    key: "root",
    storage,
  },
  rootReducer
);

export const store = configureStore({
  reducer: persistedReducer,
  preloadedState: initialState,
  middleware: [/*logger */ thunk],
});

export const persistor = persistStore(store);
